import React, { Component } from 'react';
import classNames from 'classnames';
import Popover from 'components/shared/popover';
import { Icon } from 'ui';
import PasswordForm from './PasswordForm';
import EmailInstructions from './EmailInstructions';

class ResetPassword extends Component {
  state = {
    active: false,
    showForm: false,
  };

  toggleDropdown = () => {
    this.setState(state => ({ active: !state.active }));
    this.setState(state => ({ showForm: state.active && state.showForm }));
  };

  toggleForm = () => {
    this.setState(state => ({ showForm: !state.showForm }));
  };

  render() {
    const { active, showForm } = this.state;
    const { user, canResetPassword, useWeakPasswordValidation } = this.props;
    const buttonStyles = classNames('PanelToolbar-link', {
      'PanelToolbar-link--active': active,
    });

    return (
      <div className="pos-r">
        <span
          role="button"
          tabIndex={0}
          className={buttonStyles}
          onClick={this.toggleDropdown}
          onKeyDown={e => e.key === 'Enter' && this.toggleDropdown()}
        >
          <Icon name="security" />
          <span>{t('users.notifications.password.button')}</span>
        </span>

        {active && (
          <Popover
            styleName="mw-300"
            dismissable
            dismissCallback={this.toggleDropdown}
          >
            <div className="PanelToolbar-dropdown-header">
              <h2 className="Container--sans mb-8 c-gray-darker">
                {t('users.reset_password.title')}
              </h2>
            </div>

            {showForm && (
              <PasswordForm
                user={user}
                useWeakPasswordValidation={useWeakPasswordValidation}
              />
            )}

            {!showForm && user.hasEmail && (
              <EmailInstructions
                user={user}
                canResetPassword={canResetPassword}
              />
            )}

            {!showForm && !user.hasEmail && (
              <p className="fz-16 mb-16">
                {canResetPassword
                  ? t('users.reset_password.no_email.description_and_create')
                  : t('users.reset_password.no_email.description')}
              </p>
            )}

            {canResetPassword && (
              <p className="ta-r mt-8">
                <button
                  type="button"
                  className={classNames({
                    'u-linkBtn': showForm || user.hasEmail,
                    'NewButton NewButton--fw NewButton--center NewButton--tall CustomColor--backgroundColor CustomColor--buttonBoxShadow NewButton--lessonlyBrandColor':
                      !showForm && !user.hasEmail,
                  })}
                  onClick={this.toggleForm}
                >
                  {!showForm && t('users.reset_password.create_password')}
                  {showForm &&
                    !user.hasEmail &&
                    t('users.reset_password.reset_instructions')}
                  {showForm &&
                    user.hasEmail &&
                    (user.passwordless
                      ? t('users.notifications.welcome.button')
                      : t('users.reset_password.email_instructions'))}
                </button>
              </p>
            )}
          </Popover>
        )}
      </div>
    );
  }
}

export default ResetPassword;
